import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { CommandPayload } from '../annotationCommands';
import { suggestionAnnotations } from '../data/actions';
import { getSuggestionAnnotationsCommandQueue } from '../data/reducer';

export const useSuggestionAnnotationCommandConsumer = <
  T extends keyof CommandPayload,
>(
  commandType: T,
  handler: (payload: CommandPayload[T]) => void,
) => {
  const dispatch = useDispatch();
  const commands = useSelector(getSuggestionAnnotationsCommandQueue);
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    const relevant = commands.filter((cmd) => cmd.type === commandType);
    if (relevant.length === 0) return;

    for (const cmd of relevant) {
      handlerRef.current(cmd.payload as CommandPayload[T]);
    }

    dispatch(
      suggestionAnnotations.acknowledgeCommands({
        commandIds: relevant.map((cmd) => cmd.id),
      }),
    );
  }, [commands, commandType, dispatch]);
};
